/* eslint-disable no-unused-vars */
import { useMemo, useCallback } from "react";
import { useHistory } from "react-router-dom";
import Table from "../../../components/Table/Table";
import { Header } from "../../../components";
import {
  PerformerInApprovedBaseColumns,
  PerformerRejectedBaseColumns,
} from "../../../utils/utils";
import TicketButton from "../../../components/TableComponents/TicketButton/TicketButton";
import TableLayout from "../../../layouts/TableLayout/TableLayout";
import useTicketData from "../../../hooks/useTicketData";
import useTicketFilters from "../../../utils/ticketFilters";
import ActionButtons from "../../../components/TableComponents/ActionButtons/ActionButtons";
import { ROUTES } from "../../../constants";
import useTicketExport from "../../../hooks/useTicketExport";
import NoItemsFound from "../../../components/NoItemsFound/NoItemsFound";

function InApprovel() {
  const history = useHistory();

  // Custom hooks
  const {
    searchQuery,
    allRows: filteredRows,
    loading,
    isRefreshing,
    handleRefresh,
    handleSearchQuery,
    total,
    page,
    rowsPerPage,
    handleChangePage,
    handleChangeRowsPerPage,
  } = useTicketData("PERFORMER_APPROVED", true);


  // Column configuration
  const columns = useMemo(() => {
    const updatedColumns = [...PerformerInApprovedBaseColumns];

    updatedColumns[0] = {
      width: 260,
      title: "Ticket Number",
      field: "ticketNumber",
      enableSearch: false,
      enableFilter: false,
      render: (rowData) => (
        <TicketButton
          ticketNumber={rowData.ticketNumber}
          ticketId={rowData.id}
        />
      ),
    };

    return updatedColumns;
  }, []);

  const { handleExport, isExporting } = useTicketExport(
    "PERFORMER_APPROVED",
    columns
  );

  return (
    <TableLayout
      styles={{ tableInnerWrapper: { paddingBottom: "0rem" } }}
      header={
        <Header
          searchQuery={searchQuery}
          handleSearchQuery={handleSearchQuery}
          onRefresh={handleRefresh}
          isRefreshing={isRefreshing}
          onExport={handleExport}
          isExporting={isExporting}
          disableExport={filteredRows.length === 0}
        />
      }
    >
      {filteredRows.length === 0 ? (
        <NoItemsFound />
      ) : (
        <Table
          columns={columns}
          defaultColumns={columns}
          rows={filteredRows}
          hideCheckbox
          rowHeight={45}
          setHasActiveEdits={() => {}}
          isDataLoading={loading || isRefreshing}
          serverSide
          totalRows={total}
          page={page}
          rowsPerPage={rowsPerPage}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      )}
    </TableLayout>
  );
}

export default InApprovel;
